const sessionStoragePrefix = 'schedule'

const keys = [
  'changed-schedule',
  'verification-username',
  'rows-table',
  'cols-table',
  'filters',
  'filters-for-list-schedule',
  'failed-login',
  'locale',
  'filters-for-subgroup',
  'filters-for-discipline-generated',
  'filters-for-discipline-original'
]

export const ConfigSessionStorage = Object.fromEntries(keys.map(key => [key, `${sessionStoragePrefix}-${key}`]))

export const setSessionStorageKey = (key, value) => {
  window.sessionStorage.setItem(ConfigSessionStorage[key], value)
}

export const getSessionStorageKey = key => {
  return window.sessionStorage.getItem(ConfigSessionStorage[key])
}

export const removeSessionStorageKey = key => {
  window.sessionStorage.removeItem(ConfigSessionStorage[key])
}
